import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { QuickAccessRibbon } from '../components/QuickAccessRibbon';
import { SearchService } from '../components/SearchService';
import { AboutSection } from '../components/AboutSection';
import { ServicesSection } from '../components/ServicesSection';
import { HowItWorks } from '../components/HowItWorks';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { FeesSection } from '../components/FeesSection';
import { ResourcesSection } from '../components/ResourcesSection';
import { BookingCalendar } from '../components/BookingCalendar';
import { ContactSection } from '../components/ContactSection';
import { NotSureSection } from '../components/NotSureSection';
export function HomePage() {
  return <>
      <HeroSection data-id="element-1017" />
      <QuickAccessRibbon data-id="element-1018" />
      <SearchService data-id="element-1019" />
      <AboutSection data-id="element-1020" />
      <ServicesSection data-id="element-1021" />
      <HowItWorks data-id="element-1022" />
      <TestimonialsSection data-id="element-1023" />
      <FeesSection data-id="element-1024" />
      <ResourcesSection data-id="element-1025" />
      <BookingCalendar data-id="element-1026" />
      <ContactSection data-id="element-1027" />
      <NotSureSection data-id="element-1028" />
    </>;
}